/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.settings.integration.sync.controllers', [
  'ui.bootstrap',
  'acme.common.directive.combobox',
  'acme.common.service.api',
  'acme.view.application.modals.confirm.controllers'
])

.controller('SettingsIntegrationSyncController', [
  '$scope', 
  '$uibModal',
  'ApiService',
  'TenantData',
  function(
    $scope,
    $uibModal,
    ApiService,
    TenantData
  ) {

    $scope.settingsIntegrationSync = {

      model: {},

      objectTypes: [
        {
          id: 'select',
          name: '--Select Object--',
          label: '--Select Object--'
        },
        { 
          id: 'customers',
          name: 'Customer',
          label: 'Customer'
        },
        { 
          id: 'memberships',
          name: 'Membership',
          label: 'Membership'
        },
        { 
          id: 'orders',
          name: 'Order',
          label: 'Order'
        },
      ],

      formObject: {
        objectType: false,
        acmeId: ''
      },

      tenant: {},

      initialState: true,
      loadingViewData: false,
      loadingAcmeData: false,
      loadingSfdcData: false,
      successViewData: false,

      acmeObject: "",
      sfdcObject: "",
      pushDataResponse: "",

      loadingPushData: false,
      successPushingData: false,
      errorPushingData: false,
      enablePushButton: true,

      init: function() {
        this.formObject.objectType = this.objectTypes[0];

        if (TenantData.data && TenantData.data.success) {
          this.setTenantData();
        }

        $scope.$on('$destroy', $scope.$watch('settingsIntegrationSync.formObject.acmeId', this.changeAcmeId));
      },

      setTenantData: function() {
        this.tenant = TenantData.data.tenant;
      },

      viewData: function() {
        var self = $scope.settingsIntegrationSync;

        this.initialState = false;
        this.loadingViewData = true;
        this.loadingAcmeData = true;
        this.successViewData = false;

        this.loadingPushData = false;
        this.successPushingData = false;
        this.errorPushingData = false;
        this.enablePushButton = false;

        this.acmeObject = "";
        this.sfdcObject = "";

        id_ = this.formObject.acmeId;

        switch(this.formObject.objectType.id) {
          case 'customers':
            ApiService.customers.detail({
              customerId: id_,
              includeAssociatedMemberships: true,
              includeMergeHistory: false
            }).then(this.success.getAcmeJSON, this.error.getAcmeJSON);
            ApiService.sfdc.customer.detail(id_).then(this.success.getSfdcJSON, this.error.getSfdcJSON);
            break;
          case 'memberships':
            ApiService.membership.detail(id_).then(this.success.getAcmeJSON, this.error.getAcmeJSON);
            ApiService.sfdc.membership.detail(id_).then(this.success.getSfdcJSON, this.error.getSfdcJSON);
            break;
          case 'orders':
            ApiService.orders.detail(id_).then(this.success.getAcmeJSON, this.error.getAcmeJSON);
            ApiService.sfdc.order.detail(id_).then(this.success.getSfdcJSON, this.error.getSfdcJSON);
            break;
        }
      },

      disableViewDataButton: function() {
        return (
          this.loadingViewData || 
          this.loadingPushData || 
          !this.formObject.objectType || 
          this.formObject.objectType.id === 'select' ||
          !this.formObject.acmeId
        );
      },

      pushData: function() {
        var props = {
          acmeId: this.formObject.acmeId,
          objectType: this.formObject.objectType.id,
          tenantId: this.tenant.id
        };

        this.initialState = false;
        this.loadingViewData = false;
        this.successViewData = false;

        this.loadingPushData = true;
        this.successPushingData = false;
        this.errorPushingData = false;

        ApiService.sfdc.pushData(props).then(this.success.pushData, this.error.pushData);
      },

      disablePushDataButton: function() {
        return (
          this.loadingViewData || 
          this.loadingPushData ||
          !this.formObject.objectType || 
          this.formObject.objectType.id === 'select' ||
          !this.formObject.acmeId || 
          !this.enablePushButton
        );
      },

      changeObject: function() {
        this.enablePushButton = true;
      },

      changeAcmeId: function(n, o) {
        if (n !== o) {
          $scope.settingsIntegrationSync.enablePushButton = true;
        }
      },

      openWhyMessage: function() {
        $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: function() {
              return 'Why?';
            },
            okText: function() {
              return 'Close';
            },
            modalMessage: function() {
              return 'The time it takes for data pushed from ACME to update in Salesforce can be influenced by the size of the queue. For example, if a lot of activity is taking place in your environment, this may increase the size of the queue and newly pushed data can take more time to update in Salesforce. If there is not an active queue the data should reflect in under a minute.';
            }
          }
        });
      },

      success: {
        init: function(response) {},
        viewData: function(res) {
          var self = $scope.settingsIntegrationSync;
          self.loadingViewData = false;
        },
        pushData: function(res) {
          var self = $scope.settingsIntegrationSync;
          self.loadingPushData = false;
          self.pushDataResponse = {
            type: self.formObject.objectType.label,
            code: self.formObject.acmeId
          };
          self.successPushingData = true;
        },

        getAcmeJSON: function(res) {
          var self = $scope.settingsIntegrationSync;

          self.acmeObject = res.data.payload;

          self.enablePushButton = true;
          self.loadingAcmeData = false;

          if (!self.loadingAcmeData && !self.loadingSfdcData) {
            self.loadingViewData = false;
          }

          self.successViewData = true;
        },

        getSfdcJSON: function(res) {
          var self = $scope.settingsIntegrationSync;

          self.sfdcObject = res.data.payload;

          self.loadingSfdcData = false;
          
          if (!self.loadingAcmeData && !self.loadingSfdcData) {
            self.loadingViewData = false;
          }

          self.successViewData = true;
        }
      },

      error: {
        init: function(response) {},
        viewData: function(res) {
          var self = $scope.settingsIntegrationSync;
          self.loadingViewData = false;
        },
        pushData: function(res) {
          var self = $scope.settingsIntegrationSync;
          var sfdcPushDataObject = {};
          switch(self.formObject.objectType.id) {
            case 'customers':
              sfdcPushDataObject['message'] = "Could not find Customer " + self.formObject.acmeId;
              sfdcPushDataObject['errorCode'] = 8077;
              sfdcPushDataObject['type'] = '"CUSTOMER_DNE';
              break;
            case 'memberships':
              sfdcPushDataObject['message'] = "Could not find Membership " + self.formObject.acmeId;
              sfdcPushDataObject['errorCode'] = 8014;
              sfdcPushDataObject['type'] = '"MEMBERSHIP_DNE';
              break;
            case 'orders':
              sfdcPushDataObject['message'] = "Could not find Order " + self.formObject.acmeId;
              sfdcPushDataObject['errorCode'] = 1019;
              sfdcPushDataObject['type'] = '"ORDER_DNE';
              break;

          }
          self.pushDataResponse = JSON.parse(JSON.stringify(sfdcPushDataObject));

          self.loadingPushData = false;
          self.errorPushingData = true;
        },

        getAcmeJSON: function(res) {
          var self = $scope.settingsIntegrationSync;

          switch(self.formObject.objectType.id) {
            case 'customers':
              self.acmeObject = JSON.parse('{"result":"Failure","message": "Customer not found"}');
              break;
            case 'memberships':
              self.acmeObject = JSON.parse('{"result":"Failure","message": "Membership not found"}');
              break;
            case 'orders':
              self.acmeObject = JSON.parse('{"result":"Failure","message": "Order not found"}');
              break;
          }

          self.loadingViewData = false;
          self.successViewData = true;
          self.enablePushButton = false;
        },

        getSfdcJSON: function(res) {
          var self = $scope.settingsIntegrationSync;

          switch(self.formObject.objectType.id) {
            case 'customers':
              self.sfdcObject = JSON.parse('{"result":"Failure","message": "Customer not found"}');
              break;
            case 'memberships':
              self.sfdcObject = JSON.parse('{"result":"Failure","message": "Membership not found"}');
              break;
            case 'orders':
              self.sfdcObject = JSON.parse('{"result":"Failure","message": "Order not found"}');
              break;
          }

          self.loadingViewData = false;
          self.successViewData = true;
        }
      }

    };

    $scope.settingsIntegrationSync.init();

}]);